//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Assemblies.js";
import "../no/NXObject.js";
import "../no/PartLoadStatus.js";
let d=[[],[[["deleteComponents"],"Delete",{},1,0],[[],"Suppress",{},0,0],[[],"Unsuppress",{},0,0],[[],"DisplayInformation",{},0,0],[[],"LoadRelatedGeometry",{R_:{loadStatus:"PartLoadStatus"}},0,0],[[],"GetPatternName",{R_:{name:''}},0,0],[[],"GetPatternSuppressedStatus",{R_:{isPatternSuppressed:''}},0,0],[[],"GetPatternDeferredStatus",{R_:{isPatternDeferred:''}},0,0],[["numPatternMembers"],"GetAllPatternMembers",{R_:{patternMembers:"Assemblies.PatternMember[]"}},0,0],[["numComponents"],"GetComponentsToPattern",{R_:{components:"Assemblies.Component[]"}},0,0],[["firstBaseInstanceIndex","secondBaseInstanceIndex"],"ChangeReferencePatternTemplate",{},2,0]],[]];
SPLM.Assemblies.ComponentPattern = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Assemblies.ComponentPattern";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;